import { ViewChild, Component, AfterContentInit, ViewChildren, ChangeDetectionStrategy, ChangeDetectorRef, Input, EventEmitter, Output } from '@angular/core';
import { SRTextParser } from 'prjwkt2json/dist';
import { TreeComponent } from '@circlon/angular-tree-component';
import { UUID } from 'angular2-uuid';

@Component({
  selector: 'app-projection-info',
  templateUrl: './projection-info.component.html',
  styleUrls: ['./projection-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectionInfoComponent implements AfterContentInit {
  private sample = 'PROJCS["NAD_1983_StatePlane_California_V_FIPS_0405_Feet",GEOGCS["GCS_North_American_1983",DATUM["D_North_American_1983",SPHEROID["GRS_1980",6378137,298.257222101]],PRIMEM["Greenwich",0],UNIT["Degree",0.017453292519943295]],PROJECTION["Lambert_Conformal_Conic"],PARAMETER["False_Easting",6561666.666666666],PARAMETER["False_Northing",1640416.666666667],PARAMETER["Central_Meridian",-118],PARAMETER["Standard_Parallel_1",34.03333333333333],PARAMETER["Standard_Parallel_2",35.46666666666667],PARAMETER["Latitude_Of_Origin",33.5],UNIT["Foot_US",0.30480060960121924]]';
  public nodes: Array<any> = [];
  public options: any = {};
  public prjParser: SRTextParser = new SRTextParser();
  public prjName = '';
  public authCode = '';
  public authName = '';
  public title = '';
  private prj = '';
  private _prjJSON: any = {};

  @Input('prjJSON')
  public set prjJSON(prj: any) {
    if(JSON.stringify(prj) === JSON.stringify(this._prjJSON)) return;
    this._prjJSON = prj;
    this.prjJSONChange.emit(this._prjJSON);
  }
  public get prjJSON(): any {
    return this._prjJSON;
  }
  @Output()
  prjJSONChange = new EventEmitter<any>();

  public index = -1;
  public treeReady = false;
  @ViewChild('tree', { static: true }) tree: TreeComponent;
  constructor(private changes: ChangeDetectorRef) {

  }

  ngAfterContentInit(): void {

    this.DetectTree();
  }
  DetectTree() {
    if (this.tree === undefined) {
      window.requestAnimationFrame(() => {
        this.DetectTree();
      })
      return;
    }

    this.treeReady = true;
    this.TreeReady();
  }
  TreeReady() {
    // this.SetPRJ(this.sample);
  }

  SetPRJ(prj: string) {
    this.prj = prj;
    this.prjJSON = this.prjParser.Parse(this.prj);

    this.MakeNodes();
    const nameInfo = this.nodes[0].children[0].name.split(':');
    const crsType = nameInfo.shift().trim();
    this.prjName = nameInfo.join(':').trim();
    if (!!this.prjJSON[crsType].AUTHORITY) {
      this.authName = this.prjJSON[crsType].AUTHORITY.label;
      this.authCode = this.prjJSON[crsType].AUTHORITY.values[0]
    } else {
      this.authName = this.authCode = '';
    }
    this.title = (this.authName === '') ? this.prjName : `${this.authName}:${this.authCode} &mdash; ${this.prjName}`;
    this.changes.detectChanges();
    window.requestAnimationFrame(() => {
      this.tree.treeModel.expandAll();
    })
  }
  private MakeNodes() {
    const nodes = [];
    nodes.push(this.MakeNode('Projection Info', this.prjJSON));
    this.nodes = nodes;



  }
  private MakeNode(key: string, item: any) {

    let name = key + ((!!item.label) ? ': ' + item.label : '');
    if (key === '') {
      if (!!item.label) {
        name = item.label;
      }
    }
    const children = []
    let data = {};

    if (Array.isArray(item)) {
      let subIndex = -1;
      for (const entry of item) {
        subIndex += 1;
        const subName = (!!entry.label) ? '' : '[' + subIndex + ']';
        children.push(this.MakeNode(subName, entry));
      }
    } else if (!!item.values) {
      for (const value of item.values) {
        children.push({ id: UUID.UUID(), name: value, hasChildren: false });
      }
    } else {
      for (const itemKey in item) {
        if (item.hasOwnProperty(itemKey)) {
          if (itemKey === 'label') {
            continue;
          } else {
            children.push(this.MakeNode(itemKey, item[itemKey]));
          }
        }
      }
    }
    const node: any = {
      id: UUID.UUID(),
      name: (name),
      values: (data)
    }
    if (children.length === 0) {
      node.hasChildren = false;
    } else {
      node.children = children;
    }
    return node;

  }

}
